import { useQuery, useQueries } from "@tanstack/react-query"
import { getMessage } from "../api/notifications"
import { faHourglassEmpty } from "@fortawesome/free-solid-svg-icons"

// Lấy thông báo của 1 người dùng
export const useHandleNotifications = (useridto: any) => {
    const { data: userNotifications, isLoading: isUserNotificationsLoading } = useQuery({ 
        queryKey: ["userNotifications", useridto],
        queryFn: () => useridto ? getMessage(useridto) : Promise.resolve(null),
        refetchOnMount: false,
        staleTime: 60000,
        enabled: !!useridto,
     })

     return {
        userNotifications,
        isUserNotificationsLoading
     }
}

